import { useState } from 'react';
import type { CatalogueItem } from '../SalesLadder/useSalesCatalogue';
import { isVideoItem } from '../SalesLadder/MediaBadge';
import { SalesMediaViewer } from '../Sales/SalesMediaViewer';
import { itemFull } from './resolveIds';

/** Full-screen view of catalogue items, starting at `start`, with ←/→ between them. */
export function MediaLightbox({ accountId, items, start, onClose }: { accountId: string; items: CatalogueItem[]; start: number; onClose: () => void }) {
  const [i, setI] = useState(start);
  const n = items.length;
  const it = items[i];
  if (!it) return null;
  const step = (d: number) => () => setI((x) => (x + d + n) % n);
  return (
    <SalesMediaViewer
      key={it.id}
      accountId={accountId}
      url={itemFull(it)}
      type={isVideoItem(it.type) ? 'video' : it.type}
      onClose={onClose}
      onPrev={n > 1 ? step(-1) : undefined}
      onNext={n > 1 ? step(1) : undefined}
    />
  );
}
